import apple from './apple'
import google from './google'

export default {
  ...apple,
  ...google,
}
